module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABTCAIAAACebPnyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAG5JREFUeNrs1UkKgEAMBdHOv/+dI25cZyBBtN5aKbpN8BwAAAAA+B93L7+rhYwWTqOFS9PCt8k1zKyQSZ+jkKncVTaj2jimMmqu5BObmqtIoLUfwcD9ZG0n4oHuXI3vx/iev+7/AQAAAABfcgkwACPVKhU4ycDfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/next-project.png
// module id = 549
// module chunks = 278158968741676